import { Popover, Typography } from "@commonlibs";
import InfoYellowIcon from "ui/common/icons/InfoYellowIcon";
import { InfoPopoverContent } from "./InfoPopover.styles";

function InfoPopover({ title, text,}: { title?: string; text: string; }) {
    return (
        <Popover showOn="hover" position="bottom-start">
            <Popover.Content>
                <InfoYellowIcon viewBox="0 0 16 16" />
            </Popover.Content>
            <Popover.Popper>
                <InfoPopoverContent>
                    {title && (
                        <Typography variant="body3Regular" textAlign="left">
                            {title}
                        </Typography>
                    )}
                    <Typography variant="body3Regular" textAlign="left">
                        <span dangerouslySetInnerHTML={{ __html: text }} />  {/* skipcq: JS-0440 */}
                    </Typography>
                </InfoPopoverContent>
            </Popover.Popper>
        </Popover>
    );
}

export default InfoPopover;
